var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsuranceBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1658280438244,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2557,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "@font-face { font-family: feedback-iconfont; src: url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff2?t=1630033759944\") format(\"woff2\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff?t=1630033759944\") format(\"woff\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.ttf?t=1630033759944\") format(\"truetype\"); }\n"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M649.997 241.329c-258.667-40-390 92.001-390.667 92.001-271.333 236 40.667 411.333 40.667 411.999 222 122.666 470.669 26.667 469.335 25.334 172.666-55.333 218.667-200 218.667-200s19.333 2.666 21.001 0.666c-8.999 42.666-32.856 82.761-29.001 76.667-64 103.333-206.667 230-516.667 222.667S47.999 642.665 47.999 642.665s-112-123.998 35.333-295.998 396.001-176.667 401.334-174S653.333 156 816 238.667s193 230.667 193 230.667h-25c-89.33-209.996-336.669-228.005-334.003-228.005zM677.5 718h101l63-401h-94M476 334c-116.5 40.5-108 107.5-108.5 105 31.5 80 37 40.5 116 129.5s-21.5 112-22 112c-77.5 9.5-120.5-5-120.5-5l-37.5-8V729s37 6 40.5 6 161.5 17 232.5-8 87.5-80.5 89-117-32.5-77.5-45.5-81.5-68.5-44.5-68.5-44.5-53.5-41-20-82.5 180-42.5 180-42.5l-3-42c-121-16.5-234 19-232.5 17z",
    "p-id": 2558,
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsuranceBusiness);
export default __webpack_public_path__ + "static/media/insuranceBusiness.621974ea.svg";
export { ForwardRef as ReactComponent };